import _defineProperty from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _toConsumableArray from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
import Store from "../../../../utils/Store";
import { FRONTEND_TOOL_NAMES } from "../constants";
import { useCopilotMessagesContext } from "@copilotkit/react-core";
import { ActionExecutionMessage, ResultMessage, TextMessage } from "@copilotkit/runtime-client-gql";
import { useEffect, useRef, useState } from "react";
import { cloneDeep, get, isEmpty } from "lodash";
import useEditConversation from "../services/useEditConversation";
import useAddMessages from "../services/useAddMessages";
import useCallGetNextSteps from "./useCallGetNextSteps";
function convertOpenAIToCopilot(openaiMessages) {
  var addAssistantMessageInToolCalls = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var actionNameMapToToolCallId = {};
  return openaiMessages.flatMap(function (msg) {
    var now = new Date();
    if (msg === undefined) return;
    if ((msg === null || msg === void 0 ? void 0 : msg.role) === "system" || (msg === null || msg === void 0 ? void 0 : msg.role) === "user" || (msg === null || msg === void 0 ? void 0 : msg.role) === "assistant") {
      var _msg$tool_calls;
      if (msg.tool_calls && ((_msg$tool_calls = msg.tool_calls) === null || _msg$tool_calls === void 0 ? void 0 : _msg$tool_calls.length) > 0) {
        // Each tool_call maps to ActionExecutionMessage
        var toolCalls = msg.tool_calls.map(function (toolCall) {
          actionNameMapToToolCallId[toolCall.id] = toolCall["function"].name;
          var parsedArguments = {};
          try {
            if (typeof toolCall["function"].arguments === "string" && toolCall["function"].arguments.startsWith("{")) {
              parsedArguments = JSON.parse(toolCall["function"].arguments);
            }
          } catch (error) {
            console.error("Error parsing tool call arguments:", error, toolCall["function"].arguments);
            parsedArguments = {
              raw: toolCall["function"].arguments
            };
          }
          return {
            id: toolCall.id,
            createdAt: new Date((toolCall === null || toolCall === void 0 ? void 0 : toolCall.created_at) || new Date()),
            type: "ActionExecutionMessage",
            name: toolCall["function"].name,
            arguments: parsedArguments
          };
        });
        if (!isEmpty(msg.content) && msg.role === "assistant" && addAssistantMessageInToolCalls) {
          return [{
            id: "assistant-".concat(crypto.randomUUID()),
            createdAt: new Date((msg === null || msg === void 0 ? void 0 : msg.created_at) || new Date()),
            type: "TextMessage",
            role: "assistant",
            content: msg.content || ""
          }].concat(_toConsumableArray(toolCalls));
        } else {
          return toolCalls;
        }
      } else {
        if (msg.role === "user") {
          return [{
            id: "ck-".concat(crypto.randomUUID()),
            createdAt: new Date((msg === null || msg === void 0 ? void 0 : msg.created_at) || new Date()),
            type: "TextMessage",
            role: msg.role,
            content: msg.content || ""
          }];
        } else {
          return [{
            id: "gen-".concat(crypto.randomUUID()),
            createdAt: new Date((msg === null || msg === void 0 ? void 0 : msg.created_at) || new Date()),
            type: "TextMessage",
            role: msg.role,
            content: msg.content || ""
          }];
        }
      }
    } else if (msg.role === "tool") {
      var result = "";
      try {
        if (typeof msg.content === "string" && msg.content.trim().startsWith("{")) {
          try {
            result = JSON.parse(msg.content);
          } catch (parseError) {
            // If JSON parsing fails (e.g., unterminated string), use raw content
            console.warn("Failed to parse JSON content, using raw content:", parseError instanceof Error ? parseError.message : parseError);
            result = msg.content || "";
          }
        } else {
          result = msg.content || "";
        }
      } catch (error) {
        // Fallback error handler for any unexpected errors
        console.error("Error parsing tool call result:", error);
        result = msg.content || "";
      }
      return [{
        id: "result-".concat(msg.tool_call_id || crypto.randomUUID()),
        createdAt: now,
        type: "ResultMessage",
        actionExecutionId: msg.tool_call_id || "",
        actionName: msg.tool_call_id && actionNameMapToToolCallId[msg.tool_call_id] || "",
        // Optional: you can infer or look up the action name
        result: result
      }];
    } else {
      // Fallback to a simple text message
      return [{
        id: "gen-".concat(crypto.randomUUID()),
        createdAt: now,
        type: "TextMessage",
        role: msg.role,
        content: msg.content || ""
      }];
    }
  });
}
function formatCopilotMessages(copilotMessages) {
  if ((copilotMessages === null || copilotMessages === void 0 ? void 0 : copilotMessages.length) > 0) {
    var parsedMessages = copilotMessages === null || copilotMessages === void 0 ? void 0 : copilotMessages.map(function (message) {
      if (message.type === "TextMessage") {
        return new TextMessage({
          id: message.id,
          role: message.role,
          content: message.content,
          createdAt: message.createdAt
        });
      } else if (message.type === "ActionExecutionMessage") {
        return new ActionExecutionMessage({
          id: message.id,
          name: message.name,
          // scope: message.scope,
          arguments: message.arguments,
          createdAt: message.createdAt
        });
      } else if (message.type === "ResultMessage") {
        return new ResultMessage({
          id: message.id,
          actionExecutionId: message.id.split("result-")[1],
          actionName: message.actionName,
          result: typeof message.result === "string" ? message.result : JSON.stringify(message.result),
          createdAt: message.createdAt
        });
      } else {
        throw new Error("Unknown message type: ".concat(message.type));
      }
    });
    return parsedMessages;
  }
}
function convertCopilotToOpenAI(copilotMessages) {
  return copilotMessages.map(function (msg) {
    if (msg.type === "TextMessage") {
      return {
        role: msg.role || "assistant",
        content: msg.content || ""
      };
    } else if (msg.type === "ActionExecutionMessage") {
      return {
        role: "assistant",
        content: msg.content || "",
        tool_calls: [{
          id: msg.id,
          type: "function",
          "function": {
            name: msg.name || "",
            arguments: JSON.stringify(msg.arguments || {})
          }
        }]
      };
    } else if (msg.type === "ResultMessage") {
      var content = "";
      // Ensure the result is stringified for storage
      if (typeof msg.result === "string") {
        content = msg.result;
      } else if (msg.result !== null && msg.result !== undefined) {
        content = JSON.stringify(msg.result);
      }
      return {
        role: "tool",
        tool_call_id: msg.actionExecutionId || "",
        content: content
      };
    } else {
      // Fallback: treat as plain assistant message
      return {
        role: "assistant",
        content: msg.content || ""
      };
    }
  });
}
var filterMessages = function filterMessages(messages) {
  var filteredMessages = messages.filter(function (message) {
    return !(message.type === "TextMessage" && message.role === "assistant" && message.content === "" || message.type === "ActionExecutionMessage" && message.name === "fallback_handler" || message.type === "ResultMessage" && message.actionName === "fallback_handler" || message.id.startsWith("doNotSave_") || message.content === "The task is failed. Please try again." || message.content === "❌ An error occurred. Please try again." || message.content === "");
  });
  return filteredMessages;
};
function convertOpenAIToCopilotMessages(openaiMessages, startIndex, lastIndex) {
  var startMessageIndex = startIndex;
  var lastMessageIndex = lastIndex;
  var copilotConversations = [];
  while (startMessageIndex <= lastMessageIndex) {
    var _msg$tool_calls2;
    var msg = openaiMessages[startMessageIndex];
    var toolCallMesages = [];
    if (msg.role === "assistant" && msg.tool_calls && ((_msg$tool_calls2 = msg.tool_calls) === null || _msg$tool_calls2 === void 0 ? void 0 : _msg$tool_calls2.length) === 0) {
      startMessageIndex++;
      while (startMessageIndex <= lastMessageIndex && openaiMessages[startMessageIndex].role !== "user" && openaiMessages[startMessageIndex].role !== "system" && !(openaiMessages[startMessageIndex].role === "assistant" && openaiMessages[startMessageIndex].tool_calls && ((_openaiMessages$start = openaiMessages[startMessageIndex].tool_calls) === null || _openaiMessages$start === void 0 ? void 0 : _openaiMessages$start.length) === 0)) {
        var _openaiMessages$start;
        toolCallMesages.push(openaiMessages[startMessageIndex]);
        startMessageIndex++;
      }
      var _toolCallCopilotMessages = convertOpenAIToCopilot(toolCallMesages.reverse(), true);
      var _copilotConversation = convertOpenAIToCopilot([msg])[0];
      copilotConversations.push({
        toolCalls: _toolCallCopilotMessages,
        message: _copilotConversation
      });
    }
    // if (msg.role === "system" || msg.role === "user" || msg.role === "assistant")
    else {
      var _copilotConversation2 = convertOpenAIToCopilot([msg])[0];
      copilotConversations.push({
        toolCalls: [],
        message: _copilotConversation2
      });
      startMessageIndex++;
    }
    //  else {
    //   break;
    // }
  }
  var _copilotConversations = cloneDeep(copilotConversations);
  return {
    copilotConversations: _copilotConversations.reverse(),
    startMessageIndex: startMessageIndex
  };
}
var getFormattedCopilotConversation = function getFormattedCopilotConversation(conversationMessages, copilotConversations, prevAssistantThreadId, assistantThreadId, prevConversationMessages, prevStartMessageIndex) {
  // if (prevAssistantThreadId === assistantThreadId) {
  //   let savedMessages = [...prevConversationMessages, ...conversationMessages];
  //   const {
  //     copilotConversations: _copilotConversations,
  //     startMessageIndex: _startMessageIndex,
  //   } = convertOpenAIToCopilotMessages(
  //     savedMessages,
  //     prevStartMessageIndex,
  //     savedMessages?.length - 1
  //   );
  //   return {
  //     copilotConversations: [...copilotConversations, ..._copilotConversations],
  //     startMessageIndex: _startMessageIndex,
  //     conversationMessages: savedMessages,
  //   };
  // } else {
  var savedMessages = conversationMessages;
  var _convertOpenAIToCopil = convertOpenAIToCopilotMessages(savedMessages, 0, (savedMessages === null || savedMessages === void 0 ? void 0 : savedMessages.length) - 1),
    _copilotConversations = _convertOpenAIToCopil.copilotConversations,
    _startMessageIndex = _convertOpenAIToCopil.startMessageIndex;
  return {
    copilotConversations: _copilotConversations,
    startMessageIndex: _startMessageIndex,
    conversationMessages: savedMessages
  };
  // }
};
var useConversationLogs = function useConversationLogs(_ref) {
  var conversationMessages = _ref.conversationMessages,
    conversationsData = _ref.conversationsData,
    isConversationsSuccess = _ref.isConversationsSuccess,
    userInfo = _ref.userInfo,
    assistantThreadId = _ref.assistantThreadId,
    isConversationMessagesSuccess = _ref.isConversationMessagesSuccess;
  var _useCopilotMessagesCo = useCopilotMessagesContext(),
    messages = _useCopilotMessagesCo.messages,
    setMessages = _useCopilotMessagesCo.setMessages;
  var _useState = useState(false),
    hasAttemptedCreation = _useState[0],
    setHasAttemptedCreation = _useState[1];
  var copilotConversations = useRef([]);
  var prevConversationMessages = useRef([]);
  var prevAssistantThreadId = useRef("");
  var prevStartMessageIndex = useRef(0);
  var callNextSteps = useCallGetNextSteps();
  var allowNextSteps = process.env.NEXT_PUBLIC_ALLOW_NEXT_STEPS === "true";
  useEffect(function () {
    if (isConversationMessagesSuccess === true && conversationMessages !== null && conversationMessages !== void 0 && conversationMessages.results) {
      var _getFormattedCopilotC = getFormattedCopilotConversation((conversationMessages === null || conversationMessages === void 0 ? void 0 : conversationMessages.results) || [], copilotConversations.current, prevAssistantThreadId.current, assistantThreadId, prevConversationMessages.current, prevStartMessageIndex.current),
        _copilotConversations = _getFormattedCopilotC.copilotConversations,
        _startMessageIndex = _getFormattedCopilotC.startMessageIndex,
        _conversationMessages = _getFormattedCopilotC.conversationMessages;
      var _messages = [];
      _copilotConversations === null || _copilotConversations === void 0 || _copilotConversations.forEach(function (conversation) {
        var _conversation$toolCal;
        _messages.push(conversation.message);
        var toolCallMessages = [];
        var isBackendToolCall = false;
        var backendToolCall = {
          id: "",
          createdAt: "",
          type: "ActionExecutionMessage",
          name: "",
          arguments: {}
        };
        (_conversation$toolCal = conversation.toolCalls) === null || _conversation$toolCal === void 0 || _conversation$toolCal.forEach(function (toolCall) {
          if (toolCall.type === "ActionExecutionMessage" && !FRONTEND_TOOL_NAMES.includes(toolCall.name)) {
            isBackendToolCall = true;
            backendToolCall = toolCall;
          }
          toolCallMessages.push(toolCall);
        });
        if (isBackendToolCall) {
          var _actionExecutionMessage = {
            id: backendToolCall.id,
            createdAt: backendToolCall.createdAt,
            type: "ActionExecutionMessage",
            name: "fallback_handler",
            arguments: {
              query: conversation.message.content
            }
          };
          var _resultMessage = {
            id: "result-".concat(backendToolCall.id),
            createdAt: backendToolCall.createdAt,
            type: "ResultMessage",
            actionExecutionId: backendToolCall.id,
            actionName: "fallback_handler",
            result: JSON.stringify({
              type: "success"
            })
          };
          _messages.push(_actionExecutionMessage, _resultMessage);
        } else {
          _messages.push.apply(_messages, toolCallMessages);
        }
      });
      copilotConversations.current = _copilotConversations;
      prevStartMessageIndex.current = _startMessageIndex;
      prevAssistantThreadId.current = assistantThreadId;
      prevConversationMessages.current = _conversationMessages;
      Store.update(function (s) {
        var _messages2;
        s.lastSavedMessageId = (_messages2 = _messages[(_messages === null || _messages === void 0 ? void 0 : _messages.length) - 1]) === null || _messages2 === void 0 ? void 0 : _messages2.id;
        s.hasUserSentMessage = false;
      });
      setMessages(formatCopilotMessages(_messages) || []);
      if (allowNextSteps) {
        callNextSteps.callGetNextSteps();
      }
    }
  }, [assistantThreadId, isConversationMessagesSuccess, conversationMessages === null || conversationMessages === void 0 ? void 0 : conversationMessages.results]);
  var conversations = get(conversationsData, ["results"], []);
  var editConversation = useEditConversation(userInfo === null || userInfo === void 0 ? void 0 : userInfo.default_workspace);

  // Reset creation flag when workspace changes
  useEffect(function () {
    setHasAttemptedCreation(false);
  }, [userInfo === null || userInfo === void 0 ? void 0 : userInfo.default_workspace]);
  if (isConversationsSuccess && !assistantThreadId) {
    if ((conversations === null || conversations === void 0 ? void 0 : conversations.length) > 0) {
      var conversation = conversations[0];
      if (conversation) {
        Store.update(function (s) {
          s.assistantThreadId = conversation.conversation_id;
          s.accessPastChat = true;
        });
      }
    } else if (!hasAttemptedCreation && (conversations === null || conversations === void 0 ? void 0 : conversations.length) === 0) {
      // Only create conversation once when no conversations exist
      setHasAttemptedCreation(true);
      var payload = {
        title: "New Chat ".concat(new Date())
      };
      editConversation.mutateAsync(payload).then(function (resp) {
        Store.update(function (s) {
          s.assistantThreadId = resp.conversation_id;
        });
      });
    }
  }
  var addMessages = useAddMessages(userInfo === null || userInfo === void 0 ? void 0 : userInfo.default_workspace, assistantThreadId);

  // Call the hook at top level - always safe

  var processedMessageIds = useRef(new Set());
  useEffect(function () {
    if ((messages === null || messages === void 0 ? void 0 : messages.length) > 0 && Store.getRawState().hasUserSentMessage === true) {
      var lastMessageIndex = messages.findLastIndex(function (message) {
        return message.id === Store.getRawState().lastSavedMessageId;
      }) || -1;
      var lastSuccessMessageIndex = messages.findLastIndex(function (message) {
        return message.status.code === "Success";
      });
      var filteredMessages = filterMessages(messages.slice(lastMessageIndex + 1, lastSuccessMessageIndex + 1));
      if ((filteredMessages === null || filteredMessages === void 0 ? void 0 : filteredMessages.length) > 0) {
        var newRemainingMessages = filteredMessages.filter(function (msg) {
          return !processedMessageIds.current.has(msg.id);
        });
        if ((newRemainingMessages === null || newRemainingMessages === void 0 ? void 0 : newRemainingMessages.length) > 0) {
          // Check if all ActionExecutionMessages have corresponding ResultMessages
          var actionExecutions = newRemainingMessages.filter(function (msg) {
            return msg.type === "ActionExecutionMessage";
          });
          var resultMessages = newRemainingMessages.filter(function (msg) {
            return msg.type === "ResultMessage";
          });

          // Create a set of action execution IDs that have results
          var actionIdsWithResults = new Set(resultMessages.map(function (msg) {
            return msg.actionExecutionId;
          }));

          // Check if all action executions have corresponding results
          var allActionExecutionsHaveResults = actionExecutions.every(function (actionMsg) {
            return actionIdsWithResults.has(actionMsg.id);
          });

          // Only proceed if all tool calls have results, or if there are no tool calls
          if (allActionExecutionsHaveResults || (actionExecutions === null || actionExecutions === void 0 ? void 0 : actionExecutions.length) === 0) {
            var formattedMessages = convertCopilotToOpenAI(newRemainingMessages);
            var _savedMessages = _toConsumableArray(formattedMessages);
            if ((_savedMessages === null || _savedMessages === void 0 ? void 0 : _savedMessages.length) > 0) {
              // Mark as processed before sending, to prevent race condition
              newRemainingMessages.forEach(function (msg) {
                return processedMessageIds.current.add(msg.id);
              });
              var _payload = {
                messages: _savedMessages
              };
              addMessages.mutateAsync(_payload).then(/*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(res) {
                  var hasSuccessfulResult;
                  return _regenerator().w(function (_context) {
                    while (1) switch (_context.n) {
                      case 0:
                        Store.update(function (s) {
                          var _filteredMessages, _filteredMessages$fin;
                          s.lastSavedMessageId = (_filteredMessages = filteredMessages[(filteredMessages === null || filteredMessages === void 0 ? void 0 : filteredMessages.length) - 1]) === null || _filteredMessages === void 0 ? void 0 : _filteredMessages.id;
                          s.lastSavedUserMessageId = ((_filteredMessages$fin = filteredMessages.findLast(function (msg) {
                            return msg.role === "user";
                          })) === null || _filteredMessages$fin === void 0 ? void 0 : _filteredMessages$fin.id) || "";
                          s.hasUserSentMessage = false;
                        });

                        // Check if any ResultMessage has success code before triggering next steps
                        hasSuccessfulResult = newRemainingMessages.some(function (msg) {
                          if (msg.type === "ResultMessage") {
                            try {
                              var _msg$status;
                              return (msg === null || msg === void 0 || (_msg$status = msg.status) === null || _msg$status === void 0 ? void 0 : _msg$status.code) === "Success";
                            } catch (error) {
                              return false;
                            }
                          }
                          return false;
                        });
                        if (hasSuccessfulResult) {
                          callNextSteps.callGetNextSteps();
                        }
                      case 1:
                        return _context.a(2);
                    }
                  }, _callee);
                }));
                return function (_x) {
                  return _ref2.apply(this, arguments);
                };
              }());
            }
          }
        }
      }
    }
  }, [messages, messages === null || messages === void 0 ? void 0 : messages.length]);
  var getToolCallMessages = function getToolCallMessages(messageId) {
    var _conversation$toolCal2;
    var conversation = copilotConversations.current.find(function (conversation) {
      var _conversation$message;
      return (conversation === null || conversation === void 0 || (_conversation$message = conversation.message) === null || _conversation$message === void 0 ? void 0 : _conversation$message.id) === messageId;
    });
    var toolCallMessages = conversation === null || conversation === void 0 ? void 0 : conversation.toolCalls;
    var isFrontentToolCall = conversation === null || conversation === void 0 || (_conversation$toolCal2 = conversation.toolCalls) === null || _conversation$toolCal2 === void 0 ? void 0 : _conversation$toolCal2.some(function (toolCall) {
      return FRONTEND_TOOL_NAMES.includes(toolCall.name);
    });
    if (isFrontentToolCall) {
      return [];
    } else {
      return toolCallMessages;
    }
  };
  var setToolCallMessages = function setToolCallMessages(message, toolCallMessages) {
    if ((toolCallMessages === null || toolCallMessages === void 0 ? void 0 : toolCallMessages.length) > 0) {
      var _toolCallCopilotMessages = convertOpenAIToCopilot(toolCallMessages, true);
      if (copilotConversations.current.find(function (conversation) {
        var _conversation$message2;
        return (conversation === null || conversation === void 0 || (_conversation$message2 = conversation.message) === null || _conversation$message2 === void 0 ? void 0 : _conversation$message2.id) === (message === null || message === void 0 ? void 0 : message.id);
      })) {
        copilotConversations.current = copilotConversations.current.map(function (conversation) {
          var _conversation$message3;
          return (conversation === null || conversation === void 0 || (_conversation$message3 = conversation.message) === null || _conversation$message3 === void 0 ? void 0 : _conversation$message3.id) === (message === null || message === void 0 ? void 0 : message.id) ? _objectSpread(_objectSpread({}, conversation), {}, {
            toolCalls: _toolCallCopilotMessages
          }) : conversation;
        });
      } else {
        copilotConversations.current.push({
          toolCalls: _toolCallCopilotMessages,
          message: message
        });
      }
    }
  };
  return {
    getToolCallMessages: getToolCallMessages,
    setToolCallMessages: setToolCallMessages
  };
};
export default useConversationLogs;